export default "<p>weely-rental works!</p>\r\n";